import { cva } from "class-variance-authority";

export const dateSegmentContainerStyles = cva(
  [
    "w-full border-none p-0 text-sm text-neutral-10 focus-visible:ring-0 focus-visible:outline-hidden",
    "disabled:cursor-not-allowed disabled:bg-neutral-95 disabled:text-neutral-50 disabled:placeholder:text-neutral-70",
  ],
  {
    variants: {
      variant: {
        outline: "",
        blank: "disabled:bg-transparent",
      },
    },
  }
);
